import React, { useEffect, useState } from 'react';
import { createBrowserRouter, Route, RouterProvider, Routes } from 'react-router-dom';
import { Amplify, Auth } from 'aws-amplify';

import Home from './routes/Home';
import NotificationsPage from './routes/notifications';
import DonationsPage from './routes/donations';
import CampaignsPage from './routes/campaigns';
import AnalyticsPage from './routes/analytics';
import TransactionsPage from './routes/transactions';
import GiftAidPage from './routes/gift-aid';
import EventsPage from './routes/events';
import FeatureFlagsPage from './routes/feature-flags';
import Login from './routes/login';
import DonatePaypal from './routes/donate-paypal';

import './index.css';
import ReactDOM from "react-dom/client";

Amplify.configure({
  Auth: {
    region: process.env.REACT_APP_AWS_REGION,
    userPoolId: process.env.REACT_APP_AWS_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID,
  },
  API: {
    endpoints: [
      {
        name: "MasjidNotifierAPI",
        endpoint: process.env.REACT_APP_MASJID_NOTIFIER_API,
        custom_header: async () => {
           return {
             Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
             'x-api-key': process.env.REACT_APP_MASJID_NOTIFIER_API_KEY
           }
        }
      },
      {
        name: "DonationsAPI",
        endpoint: process.env.REACT_APP_DONATIONS_API,
        custom_header: async () => {
           return {
             Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
           }
        }
      }
    ]
  }
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleAuthChange = (authenticated: boolean) => {
    setIsAuthenticated(authenticated);
  };

  useEffect(() => {
    const checkAuth = async () => {
      try {
        await Auth.currentAuthenticatedUser();
        console.log('user is authenticated so getting current session');
        await Auth.currentSession();
        setIsAuthenticated(true);
      } catch (err) {
        setIsAuthenticated(false);
        console.log('user is not authenticated');
      }
    };

    (async () => {
      await checkAuth();
    })().catch((err) => {
      console.log(err);
    });
  }, [isAuthenticated]);

  const router = createBrowserRouter([
    {
      path: '/',
      element: (
        <Routes>
        {/* Only render Home component if user is authenticated */}
        {isAuthenticated ? (
          <Route path="/" element={<Home />} />
        ) : (
          <Route path="*" element={<Login onAuthChange={handleAuthChange} />} />
        )}
      </Routes>
      ),
    },
    {
      path: '/notifications',
      element: isAuthenticated ? <NotificationsPage /> : <Login onAuthChange={handleAuthChange} />,
    },
    {
      path: '/donations',
      element: isAuthenticated ? <DonationsPage /> : <Login onAuthChange={handleAuthChange} />,
    },
    {
      path: '/campaigns',
      element: isAuthenticated ? <CampaignsPage /> : <Login onAuthChange={handleAuthChange} />,
    },
    {
      path: '/analytics',
      element: isAuthenticated ? <AnalyticsPage /> : <Login onAuthChange={handleAuthChange} />,
    },
    {
      path: '/transactions',
      element: isAuthenticated ? <TransactionsPage /> : <Login onAuthChange={handleAuthChange} />,
    },
    {
      path: '/gift-aid',
      element: isAuthenticated ? <GiftAidPage /> : <Login onAuthChange={handleAuthChange} />,
    },
    {
      path: '/events',
      element: isAuthenticated ? <EventsPage /> : <Login onAuthChange={handleAuthChange} />,
    },
    {
      path: '/feature-flags',
      element: isAuthenticated ? <FeatureFlagsPage /> : <Login onAuthChange={handleAuthChange} />,
    },
    {
      path: '/login',
      element: <Login onAuthChange={handleAuthChange} />,
    },
    {
      path: '/donate-paypal',
      element: <DonatePaypal />,
    },
  ]);

  return (
    <RouterProvider router={router} />
  );
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

export default App;